/**
 * SectionExploreDestinations
 * 
 * A PageBuilder section that displays the ExploreDestinations component.
 * This integrates the SEO location links into the CMS-driven landing page.
 */

import ExploreDestinations from '../../../../components/ExploreDestinations/ExploreDestinations';
import css from './SectionExploreDestinations.module.css';

const SectionExploreDestinations = props => {
    const { sectionId } = props;

    return (
        <section id={sectionId} className={css.root}>
            <ExploreDestinations />
        </section>
    );
};

export default SectionExploreDestinations;
